export const ArtistsAddButtonSx = {
  borderColor: "rgba(255,255,255,0.22)",
  color: "rgba(255,255,255,0.8)",
  px: 3,
  fontWeight: 600,
  fontSize: "0.75rem",
  letterSpacing: "0.12em",
  height: "40px",
  "&:hover": {
    borderColor: "white",
    backgroundColor: "rgba(255,255,255,0.06)",
    color: "white",
  },
};

export const ArtistLoadMoreButtonSx = {
  mt: 4,
  mb: 2,
  color: "rgba(255,255,255,0.6)",
  borderColor: "rgba(255,255,255,0.18)",
  display: "block",
  width: "120px",
  letterSpacing: "0.1em",
  fontSize: "0.72rem",
  fontWeight: 600,
  "&:hover": {
    borderColor: "rgba(255,255,255,0.5)",
    backgroundColor: "rgba(255,255,255,0.05)",
    color: "white",
  },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.2)",
    borderColor: "rgba(255,255,255,0.08)",
  },
};
